var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOcr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#FFC1C1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6079_1732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 13.3334C18.6668 15.8475 18.6668 17.1046 17.8858 17.8857C17.1047 18.6667 15.8477 18.6667 13.3335 18.6667",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 18.6667C8.15267 18.6667 6.89559 18.6667 6.11454 17.8857C5.3335 17.1046 5.3335 15.8475 5.3335 13.3334",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 5.33337C8.15267 5.33337 6.89559 5.33337 6.11454 6.11442C5.3335 6.89547 5.3335 8.15255 5.3335 10.6667",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14L16 14",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12L16 12",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10L16 10",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 5.33337C15.8477 5.33337 17.1047 5.33337 17.8858 6.11442C18.6668 6.89547 18.6668 8.15255 18.6668 10.6667",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6079_1732"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 5,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOcr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ocr.23af31d79cffe28de8e526429ed62a1e.svg";